/** @format */

import { useEffect, useState } from 'react';

const usePageRendered = (): string => {
    const [pageRendered, setPageRendered] = useState<boolean>(false);

    useEffect(() => {
        // This function will be called after the component has successfully rendered
        setPageRendered(true);

        // You can perform any actions here based on the successful rendering of the page
        // For example, you can add a CSS class or trigger animations

        // Clean up the state on component unmount
        return () => {
            setPageRendered(false);
        };
    }, []);

    return pageRendered ? 'page-route active' : 'page-route';
};

export default usePageRendered;
